import { legacy_createStore as createStore } from 'redux';
import rootReducer from './reducers' // './reducers';
// import storage from "redux-persist/lib/storage";
const store = createStore(rootReducer);
export default store;